import type { PilotCapability } from '@shared';
import { PilotRestricted, type PilotRestrictedProps } from '@/shared/components/pilot-restricted';
import { useIsNylPilotClientCreationRestricted } from '@/shared/hooks/use-nyl-pilot-advisor';

export const NYL_PILOT_CLIENT_CREATION_RESTRICTED_TOOLTIP =
  'This feature will be available in a later phase of the pilot.';

interface NylPilotClientCreationRestrictedProps extends Omit<
  PilotRestrictedProps,
  'capability' | 'restricted' | 'tooltipText'
> {
  capability?: PilotCapability;
}

export function NylPilotClientCreationRestricted({
  children,
  capability,
  ...props
}: NylPilotClientCreationRestrictedProps) {
  const isRestricted = useIsNylPilotClientCreationRestricted();

  if (!capability && !isRestricted) {
    return <>{children}</>;
  }

  return (
    <PilotRestricted
      {...props}
      capability={capability ?? 'invite-client'}
      restricted={isRestricted}
      tooltipText={isRestricted ? NYL_PILOT_CLIENT_CREATION_RESTRICTED_TOOLTIP : undefined}
    >
      {children}
    </PilotRestricted>
  );
}
